import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CommonCustomConatinerStyles {
    container?: InjectableCss;
}

export const CommonConatinerStyles: CommonCustomConatinerStyles = {
    container: {
        css: css`
            border: #e1e1e1 1px solid;
            background: #fafafa;
            padding: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 10px;
                        `,
                        null,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        null,
                    ],
                    "min",
                )}
        `,
    },
};

const styles = CommonConatinerStyles;

const CommonCustomConatiner: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CommonCustomConatiner,
    definition: {
        displayName: "Common Custom Container",
        group: "Brands",
    },
};

export default widgetModule;
